/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Close } from '../private/icons/Close';
import { ArrowBack } from '../private/icons/ArrowBack';
import { IconButton } from '../button/IconButton';

const DrawerAction = React.forwardRef((props, ref) => {

  const {
    style,
    smallScreen = false,
    ...other
  } = props;

  const classes = 'sui-flex sui-items-start sui-items-center sui-pl-0 sui-pb-0 sui-pr-4 sui-ml-auto sui--m-2';

  return (
    <div
      className={classes}
      ref={ref}
      {...other}
    />
  );
});

const DrawerHeaderRoot = React.forwardRef((props, ref) => {

  const {
    style,
    smallScreen = false,
    extraRightPadd = false,
    ...other
  } = props;

  const classes = classNames('sui-sticky sui-top-0 sui-bg-primary sui-flex sui-flex sui-w-full sui-text-left sui-flex-col sui-gap-1 sui-py-2 sui-pl-4', {
    'sui-pr-2': !extraRightPadd,
    'sui-pr-4': extraRightPadd,
  });

  return (
    <div
      className={classes}
      ref={ref}
      {...other}
    />
  );
});

const DrawerHeader = (props) => {

  const {
    children,
    endAction,
    onBack,
    onClose,
    startAction
  } = props;

  // const titleClasses = classNames('sui-flex sui-items-start sui-items-center sui-pl-0 sui-pb-0', {
  //   'sui-ml-auto': !!onBack || startAction
  // })

  return (
    <DrawerHeaderRoot extraRightPadd={!!onBack}>
      <div className="sui-flex">
        {startAction != null ? (
          <DrawerAction>
            {startAction}
          </DrawerAction>
        ) : null}
        {startAction == null && onBack ? (
          <div className="sui-flex sui-items-center">
            <IconButton
              aria-label="drawer-close"
              onClick={onBack}
              icon={ArrowBack}
            />
          </div>
        ) : null}
        {children}
        {endAction != null ? (
          <DrawerAction>
            {endAction}
          </DrawerAction>
        ) : null}
        {endAction == null && onClose ? (
          <DrawerAction>
            <IconButton
              aria-label="drawer-close"
              onClick={onClose}
              icon={Close}
            />
          </DrawerAction>
        ) : null}
      </div>
    </DrawerHeaderRoot>
  );
};

DrawerHeader.displayName = 'DrawerHeader';

DrawerHeader.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
  onBack: PropTypes.func,
  endAction: PropTypes.node,
  startAction: PropTypes.node
};

DrawerHeader.defaultProps = {
};

export { DrawerHeader };